
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmMenuItem,
  VmIcon 
} from '@vime/core';

import { define } from '../lib';
  

const MenuItemInputs: string[] = [
  'identifier',
  'hidden',
  'label',
  'menu',
  'expanded',
  'checked',
  'hint',
  'badge',
  'checkIcon',
  'icons',
  'isTouch',
];

const MenuItemMethods: string[] = [
  'focusItem',
  'blurItem',
  'getHeight',
];

const MenuItemOutputs: string[] = [
  'vmFocus',
  'vmBlur',
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface MenuItem extends Components.VmMenuItem {}

@ProxyCmp({
  inputs: MenuItemInputs,
  methods: MenuItemMethods,
})
@Component({
  selector: 'vm-menu-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: MenuItemInputs,
  outputs: MenuItemOutputs,
})
export class MenuItem {
  protected el: HTMLElement;

  /** Emitted when the item is focused. */
  vmFocus!: Emitter<JSX.VmMenuItem["onVmFocus"]>;
  /** Emitted when the item loses focus. */
  vmBlur!: Emitter<JSX.VmMenuItem["onVmBlur"]>;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-menu-item', VmMenuItem);
    define('vm-icon', VmIcon);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, ['vmFocus', 'vmBlur'])
  }
}
  